/* Library */
import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
// import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';

/*  components */
import ApplyCSS from '../../../../../components/ApplyCSS';
import MiniNotifications from '../../../../../components/Notifications/components/MiniNotifications';

/* actions */
import * as labelsActions from '../../../../../components/labels/actions';
import * as notificationsActions from '../../../../../components/Notifications/actions';


/* constants */
// const { loadNotificationsDetail } = notificationsActions;
const { isLablesLoaded, loadLables } = labelsActions;
const pageName = 'notifications';


@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  notificationLoaded: store.notifications.loaded,
  notifications: store.notifications.data,
}),
  { ...notificationsActions })

class DetailedNotifications extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.params.eventID ? this.props.params.eventID : '';
    this.profileId = this.props.params.profileId ? this.props.params.profileId : '';
  }

  UNSAFE_componentWillMount() {
    this.props.loadNotificationsDetail(this.eventId, this.profileId);
  }

  render() {
    let notifications = [];
    if (this.props.notifications && this.props.notifications.notifications) {
      notifications = this.props.notifications.notifications;
    }
    const notificationDetail = (items) => {
      const _html = [];
      items.forEach((item, index) => {
        if (item) {
          _html.push(<MiniNotifications key={index} data={item} eventId={this.eventId} profileId={this.profileId} />);
        }
        return null;
      });
      return _html;
    };
    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <div className="contentNotifications">
          <div className="container wrapNotifications">
            <div className="smallerContainer">
              <h1 className="titleSection title">Notificaciones</h1>
              <div className="content">
                <ul className="listNotification">
                  {notifications && notifications.length ?
                    notificationDetail(notifications)
                    :
                    <li className="information">
                      <div className="col-md-12 text-center allNotifications">
                        <a href="#">No Notificationes
                          <i className="icon-flecha_lightsvg_derecha" />
                        </a>
                      </div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default DetailedNotifications;
